<template>
  <div class="list-category">
    <div ref="wrapRef" class="list-category__list">
      <nuxt-link
        v-for="(item, index) in listCategory"
        :id="`item-${item.alias}`"
        ref="itemRef"
        :key="index"
        :to="getHref(item?.alias)"
        class="list-category__list--item"
        :class="{
          active: postCategoryAlias === item.alias
        }"
        @click.prevent="onChangeCategory(index, item)"
      >
        {{ item.display_name }}
      </nuxt-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ICategory } from '~/types/news'
import { NEWS } from '~/config/news'
import { PAGE_URLS } from '~/config/page-url'

interface Props {
  listCategory: ICategory[];
  postCategoryAlias?: string;
}

const wrapRef = ref<HTMLElement | null>(null)
const itemRef = ref<HTMLElement | null>(null)

const emit = defineEmits<{(e: 'change-category', alias?: string): void;}>()

const route = useRoute()
const props = defineProps<Props>()

const scrollToActive = (delay = 100, item: ICategory | string | undefined) => {
  setTimeout(() => {
    const wrap = wrapRef.value
    const categoryActiveElement = document.querySelector<HTMLElement>(`#item-${(item as ICategory).alias || item}`)
    const categoryActiveInfor = {
      offsetLeft: categoryActiveElement?.offsetLeft || 0,
      width: categoryActiveElement?.clientWidth || 0
    }
    if (categoryActiveInfor && wrap) {
      const position = categoryActiveInfor.offsetLeft - wrap.clientWidth / 2 + categoryActiveInfor.width / 2
      wrap.scrollTo({ left: position, behavior: 'smooth' })
    }
  }, delay)
}

onMounted(() => {
  const alias = route.path.split('/').pop()
  if (alias) {
    scrollToActive(100, alias as string)
  }
})

watch(route, () => {
  const alias = route.path.split('/').pop()
  if (alias) {
    scrollToActive(100, alias as string)
  }
})

const onChangeCategory = (index: number, item: ICategory) => {
  scrollToActive(100, item)
  emit('change-category', item?.alias)
}

const getHref = (alias: string | unknown) => {
  return alias === 'all' ? PAGE_URLS.NEWS : `${NEWS.pathCategory}${alias}`
}
</script>

<style scoped lang="scss" src="public/assets/scss/components/mobile/pages/news/list-category.scss" />
